import { z } from "zod";

/** The source catalog's stated period of use; fictional designs can carry dates too. */
export const AssetUsagePeriod = z
  .strictObject({
    fromYear: z.int(),
    toYear: z.int().nullable(),
    isHistorical: z.boolean(),
  })
  .meta({
    id: "AssetUsagePeriod",
    description: "The source catalog's stated usage years and historical classification.",
  });
export type AssetUsagePeriod = z.infer<typeof AssetUsagePeriod>;
